module.exports = __webpack_public_path__ + "img/upload-icon.77705dda.svg";